import { cssVarTextColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
const { white } = cssVarTextColors

export const sheet: Styles = {
  circle: {},
  mobileMenu: {
    display: 'none'
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    position: 'relative',
    width: '100%',
    maxWidth: 'inherit',
    boxSizing: 'border-box',
    gridArea: 'nav',
    '& p.createdAt': {
      width: '100%',
      textAlign: 'right',
      color: '#565656',
      fontSize: 12,
      margin: '5px 0 0',
      alignSelf: 'flex-end'
    }
  },
  leftHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,

    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '22px',
    color: white,

    '& img': {
      maxWidth: '30px'
    }
  },
  logoWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 42,
    flexShrink: 0
  },
  logoImage: {
    display: 'block',
    maxWidth: '30px'
  },
  logoVersion: {
    position: 'absolute',
    right: -5,
    bottom: 0,
    fontSize: 9,
    lineHeight: 1,
    fontWeight: 700,
    letterSpacing: '-0.3px',
    color: 'rgba(205, 205, 255, 0.9)',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.7)',
    pointerEvents: 'none',
    userSelect: 'none'
  },
  rightHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-end',
    gap: '16px'
  },
  arrow: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: '100%',
    top: 0,
    right: 0
  },
  notifications: {
    position: 'relative',
    cursor: 'default',
    paddingRight: '10px',
    '& > $circle': {
      position: 'absolute',
      width: 20,
      height: 20,
      backgroundColor: '#286EFA',
      fontWeight: '500',
      fontSize: 12,
      textAlign: 'center',
      letterSpacing: '0.03em',
      textTransform: 'capitalize',
      color: '#F0F0F0',
      borderRadius: '50%',
      top: -10,
      right: -0
    }
  },
  clickArea: {
    cursor: 'default'
  },
  '@media (max-width: 767px)': {
    mobileMenu: {
      display: 'block'
    }
  }
}
